const FORBIDDEN_CLIENT_KEYS = new Set([
  'doctorEmails',
  'emails',
  'from',
  'html',
  'recipients',
  'subject',
  'template',
  'to',
  'replyTo',
]);

export function sanitizeClientFormMetadata(
  metadata: Record<string, unknown>,
): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(metadata).filter(
      ([key, value]) => value !== undefined && !FORBIDDEN_CLIENT_KEYS.has(key),
    ),
  );
}
